<template>
  <div>
    <div class="container-fluid mt--7">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-4 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none"> Propagandas </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">Propagandas</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-5 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-propaganda">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Propaganda
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Categoria</th>
                  <th>Data de Expiração</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-propaganda
                    v-for="propaganda in state.propagandas"
                    :key="propaganda.id"
                    :propaganda="propaganda"
                    @deletarPropaganda="deletarPropaganda"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    <script>
import { onMounted, reactive } from "vue";
import CorpoTabelaPropaganda from "../../components/CorpoTabelaPropaganda";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaPropaganda,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      colunistas: [],
    });
    onMounted(() => {
      fetchPropagandas();
    });
    async function fetchPropagandas() {
      try {
        const { data } = await services.propaganda.getAll({ token });
        state.propagandas = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarPropaganda(id) {
      if (confirm("Deseja deletar o propaganda?")) {
        try {
          state.isLoading = true;
          const { data } = await services.propaganda.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar propaganda.");
          } else {
            fetchPropagandas();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarPropaganda,
    };
  },
};
</script>
  
  <style scoped>
table {
  color: black;
}
.div_btn_colunista {
  text-align: right;
  padding-right: 30px;
}
.div_tabela {
  height: auto;
}
.div_btn_usuario {
  text-align: right;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>